export default __webpack_public_path__ + "static/media/logo_cash_box.2c8da578.jpg";